import React from 'react';
import styled from 'styled-components';
import { logout } from '../../utils/authUtils';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  max-width: 40rem;
  margin: 4rem auto;
  padding: 2rem;
  background-color: white;
  border-radius: 0px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  text-align: center;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  color: #4b5563;
  margin-bottom: 1.5rem;
`;

const LogoutButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0px;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  background-color: #47ABDB;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;

// Placeholder landing page — the full speaker profile/session workflow is a
// separate, not-yet-specced piece of work. This proves the login works.
const SpeakerDashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/speaker/login');
  };

  return (
    <Container>
      <Title>Welcome</Title>
      <Subtitle>You're logged in as a speaker. Your session details will appear here soon.</Subtitle>
      <LogoutButton onClick={handleLogout}>Log out</LogoutButton>
    </Container>
  );
};

export default SpeakerDashboard;
